<div style="width: 100%;overflow: scroll;margin-top: 0.5rem;">
    <table class="table table-hover">
        <thead style="  background: #182F7C;color: #FFFFFF;
    ">
        <tr>
            <th  scope="col" *ngFor="let value of tableHeader">{{value}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor = "let row of tableData; let first = first">
            <td *ngFor = "let colume of row">{{colume}}</td>
        </tr>
        </tbody>
    </table>
</div>
<div class="d-flex justify-content-center p-1 mb-2">
    <button type="button" class="btn btn-primary" style="width: 65%;height: 35px;background: #182F7C;
border-radius: 18px;border-color: #182F7C;margin-top: 10px;font-size: 12px; box-shadow: none !important; "  data-toggle="modal" data-target="#exampleModal1"

    >View Table in seperate view</button>

</div>
<div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf = "table.hasOwnProperty('tableName') && table.tableName"
                    class="modal-title" style="color: #1D2126; font-weight: 600;font-size: 14px"
                    id="exampleModalLabel">{{ table.tableName }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div style="width: 100%; overflow: scroll;">
                    <table class="table table-hover">
                        <thead style="  background: #182F7C;color: #FFFFFF;
    ">
                        <tr>
                            <th  scope="col" *ngFor="let value of tableHeader">{{value}}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor = "let row of tableData; let first = first">
                                <td *ngFor = "let colume of row">{{colume}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
